/**
 * The panel where a tenant translates their OWN form.
 *
 * Worth more than a large fraction of the app chrome, and the code says so: a form's questions are
 * tenant-owned data in a JSONB column, so translating the application perfectly would still leave an
 * operator reading English safety questions.
 */
export default {
  title: 'Translations',
  subtitle: 'The words on this form, in another language. Anything you leave blank is shown in the '
    + 'form’s own language — never blank, never a code.',
  addLanguage: 'Add a language',
  removeLanguage: 'Remove this language',
  removeLanguageConfirm: (name) => `Remove ${name} from this form? Everyone reading it in ${name} `
    + `goes back to the form’s own language.`,
  noLanguagesYet: 'This form is only written in one language.',
  baseLanguageIs: (name) => `This form is written in ${name}.`,
  progress: (done, total) => `${done} of ${total} translated`,
  allTranslated: 'Everything is translated.',
  untranslatedCount: (n) => (n === 1 ? '1 not translated' : `${n} not translated`),
  staleCount: (n) => (n === 1
    ? '1 was written for wording that has since changed'
    : `${n} were written for wording that has since changed`),
  showOnlyMissing: 'Show only what is missing',
  original: 'Original',
  translation: 'Translation',
  stale: 'The original changed',
  stillCorrect: 'This translation still fits the new wording',
  staleHelp: 'This was translated from wording that has since been edited, so the form is showing '
    + 'the original until it is retranslated. The two languages asking different questions is worse '
    + 'than one of them being untranslated.',
  saveTranslations: 'Save translations',
  savedTranslations: 'Translations saved',
  saveFailed: 'Those translations could not be saved.',
  nothingToSaveYet: 'Nothing has been translated yet, so there is nothing to save. A language with '
    + 'no words in it would offer itself on the sheet and then show English.',
  documentSection: 'The form itself',
  formName: 'Form name',
  fieldLabel: 'Question',
  fieldHelp: 'Help text',
  elementText: 'Text',
  sectionTitle: 'Section heading',
  rows: 'Checklist items',
  options: 'Answers',
  columns: 'Table columns',
  cannotEditBase: 'This is the form’s own language. Edit the form to change these words.',
  noPermission: 'You do not have permission to translate forms.',
  pickVersion: 'Version',
}
